import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class CompetitionDeleted extends DomainEvent<DeletedEntity> {}
